import React from 'react';
import PropTypes from 'prop-types';
import { Item } from 'semantic-ui-react';
import css from './ServiceHeader.scss';
import ResponsiveView from '../../common/ResponsiveView';
import WaitingRoom from '../home/services/WaitingRoom';
import { getColorFromImage } from "utils/colors";
import { determineServiceName } from 'utils/search';

export default class ServiceHeader extends React.Component {

  constructor() {
    super();
    this.state = { borderBottomColor: "#EFEFEF" };
  }

  componentDidMount() {
    const imageURL = `../instructor/photo.html?type=S&size=F&id=${encodeURIComponent(this.props.uuid)}`;
    getColorFromImage(imageURL)
      .then(borderBottomColor => this.setState({borderBottomColor}))
      .catch(e => {}); // eslint-disable-line no-unused-vars
  }

  get imageStyle() {
    const imageURL = `../instructor/photo.html?type=S&size=F&id=${encodeURIComponent(this.props.uuid)}`;
    return { backgroundImage: `url(${imageURL})` };
  }

  get borderBottomStyle() {
    return `16px solid ${this.state.borderBottomColor}`;
  }

  render() {
    return (
      <Item.Group unstackable className={css['item-group-container']}>
        <Item className={css['item-container']} style={{borderBottom: this.borderBottomStyle}}>
          <div><div className={css['image']} style={this.imageStyle} /></div>
          <Item.Content className={css['content']}>
            <Item.Header className={css['header']}>
              {determineServiceName(this.props.name, this.props.serviceDisplayName, this.props.isStudent)}
              <ResponsiveView showIn={['tablet', 'desktop']}>
                <div className={css['waiting-container']}>
                  <WaitingRoom
                    kioskQueueSize={this.props.kioskQueueSize}
                    kioskMaxWaitTime={this.props.kioskMaxWaitTime}
                    kioskId={this.props.kioskId}
                    displayStudentQueue={this.props.displayStudentQueue}
                    isServiceMember={this.props.isServiceMember}
                    kioskType={this.props.kioskType}
                  />
                </div>
              </ResponsiveView>
            </Item.Header>
          </Item.Content>
        </Item>
      </Item.Group>
    );
  }
}

ServiceHeader.propTypes = {
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string,
  serviceDisplayName: PropTypes.string,
  kioskQueueSize: PropTypes.number,
  kioskMaxWaitTime: PropTypes.number,
  kioskId: PropTypes.number,
  displayStudentQueue: PropTypes.bool,
  isServiceMember: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  kioskType: PropTypes.string
};
